module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/attractions-onsen-53c8574e0e7b85d7b519f69403fe438d.jpg";